(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('PrintContentDialogController', PrintContentDialogController);

    PrintContentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PrintContent'];

    function PrintContentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, PrintContent) {
        var vm = this;
//        vm.printContent1 = [{code:'C01',description:'Mới', reason:'System allows to input reason if reason are “Mới” and “Điều chỉnh”',status:'1'},
//                              {code:'C02',description:'Điều chỉnh', reason:'System allows to input reason if reason are “Mới” and “Điều chỉnh”',status:'1'},
//                              {code:'C03',description:'Không đổi', reason:'System allows to input reason if reason are “Mới” and “Điều chỉnh”',status:'1'}];
//        vm.printContent = vm.printContent1[0];
        vm.printContent = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.printContent.printContentCode != null || vm.printContent.printContentCode != undefined) {
       	 vm.checkcreat = true;
       	vm.printContent.isExit = true;
        }else{
    	   vm.printContent.isExit = false;
    	   vm.printContent.status="0";
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if (vm.printContent.isExit == true) {
            	
            	PrintContent.update(vm.printContent,function(result){
          		  $scope.$emit('masterApp:printContentUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
		});
            } else {
            	PrintContent.save(vm.printContent,function(result){
        		  $scope.$emit('masterApp:printContentUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:printContentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
